import * as React from 'react'
import { memo } from 'react'
const SvgRestaurant = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.201 12">
    <path d="m.565 12-.364-.364 7.355-7.355a2.7 2.7 0 0 1-.182-1.72 3.27 3.27 0 0 1 .91-1.52A3.9 3.9 0 0 1 9.959.094a1.64 1.64 0 0 1 1.748.4 1.64 1.64 0 0 1 .4 1.748 3.9 3.9 0 0 1-.947 1.675 3.27 3.27 0 0 1-1.52.91 2.7 2.7 0 0 1-1.72-.182L6.464 6.101l5.534 5.534-.364.364-5.534-5.5Zm2.257-6.117L.856 3.917a2.8 2.8 0 0 1-.847-1.8A2.78 2.78 0 0 1 .564.206l3.969 3.969Z" />
  </svg>
)
const Memo = memo(SvgRestaurant)
export default Memo
